/* eslint-disable react/prop-types */

import React from "react";

import styled from "styled-components";

const ContentWrapper = styled.div`
  height: calc(100vh - 120px); // Adjust based on your navbar/footer heights
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
`;

const Content = ({ children }) => (
  <ContentWrapper>
    <ScrollableContent>
      {children}
    </ScrollableContent>
  </ContentWrapper>
);

//const Content = ({ children }) => <div className="content">{children}</div>;

export default Content;
